import { useState } from "react"

// Hook to persist data onto localstorage
// used to store starter loader states and currency context state
export const useLocalStorage = (key, initialValue) => {
  // State to store value
  const [error, setError] = useState(false)
  const [storedValue, setStoredValue] = useState(() => {
    try {
      // Get from local storage by key
      const item = window.localStorage.getItem(key)
      // Parse stored json or if none return initialValue
      return item ? JSON.parse(item) : initialValue
    } catch (error) {
      // If error also return initialValue
      console.log(error)
      setError(true)
      return initialValue
    }
  })
  // setter function that persists the new value to localStorage.
  const setValue = (value) => {
    try {
      // same API as useState
      const valueToStore =
        value instanceof Function ? value(storedValue) : value
      // Save state
      setStoredValue(valueToStore)
      // Save to local storage
      window.localStorage.setItem(key, JSON.stringify(valueToStore))
    } catch (error) {
      setError(true)
      console.log(error)
    }
  }
  return [storedValue, setValue, error]
}
